/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import {ProgramStatusEnum} from "@/core/js/model/Program/CoachingProgram";

export default class ProgramInfo extends DbBaseObject{

	programId: ?string = null
	programName: ?string = null
	programDescription: ?string = null
	status: string = ProgramStatusEnum.PENDING// ProgramStatusEnum
	// inviteId: string = null
	coachId: string = null


	constructor(programName: string) {
		super();
		this.programName = programName;
	}

	isNew(){
		return this.status === ProgramStatusEnum.NEW
	}

	isPending(){
		return this.status === ProgramStatusEnum.PENDING
	}
	isActive(){
		return this.status === ProgramStatusEnum.ACTIVE
	}
	isArchived(){
		return this.status === ProgramStatusEnum.ARCHIVED
	}

	statusFormatted(){
		return ProgramStatusEnum.formattedInvite(this.status);
	}

	statusColorClass(){
		return ProgramStatusEnum.colorClass(this.status);
	}
}
